import { ComponentInstance } from "@uniformdev/canvas";

import { SideNavCollection } from "@/libraries/design/components";
import { SideNavCollectionProps } from "@/libraries/design/components/side-nav-collection/src/side-nav-collection";

export interface UniformSideNavCollectionProps {
    component: ComponentInstance;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformNavItemData = (slots: any) => {
    return slots.map((childComponent: ComponentInstance) => {
        const childProps = childComponent.parameters ?? {};
        if (childComponent.type === "sideNavLink") {
            return {
                type: "link",
                text: childProps["text"]?.value as string,
                href: childProps["href"]?.value as string
            };
        }
        if (childComponent.type === "sideNavCollection") {
            return {
                type: "collection",
                collectionName: childProps["collectionName"]?.value as string,
                sideNavItems: transformNavItemData(
                    childComponent.slots?.["sideNavItems"]
                )
            };
        }
        return;
    });
};

const UniformSideNavCollection = ({
    component
}: UniformSideNavCollectionProps) => {
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;

    const sideNavItems = transformNavItemData(slotItems);
    const props: SideNavCollectionProps = {
        type: "collection",
        collectionName: component.parameters?.["collectionName"]
            ?.value as string,
        sideNavItems: sideNavItems
    };
    return <SideNavCollection {...props} />;
};

export default UniformSideNavCollection;
